import { ANALYTICS_EVENTS } from '../events'
import createAnalyticsStatic, { EventProps } from './createAnalyticsEvent'

export interface BlogFilterAppliedProps extends EventProps {
    category?: string
    query?: string
    results_count?: number
}

/**
 * @event blog_filter_applied
 * @description Emitted when the blog list filter/search is applied (category or search query).
 */
export const BlogFilterAppliedAnalytics = createAnalyticsStatic<BlogFilterAppliedProps>(
    ANALYTICS_EVENTS.BLOGS.BLOG_FILTER_APPLIED,
)

export default BlogFilterAppliedAnalytics
